/**
 * @TO_DO @TECH_DEBT
 *
 * Once xoon is no longer taking traffic and we do not
 * fallback for an flows we can remove this function
 * and the line where it is called in `./src/index.jsx`
 */

// Internal modules
import { logger } from './logger';
import { getParams } from './utils/params';
import { features } from './features';

const INELIGIBLE_FLOWS = [
  {
    name: 'in_context_shipping_callback',
    test: () => features.isActive('isShippingCallbackV1Ineligible'),
  },
  {
    name: 'popup_bridge_and_native_xo',
    test: () => Boolean(getParams().native_xo || getParams().redirect_uri),
  },
];

export const isLiteEligible = (): boolean => {
  const eligibilityViolation = INELIGIBLE_FLOWS.find(({ test }) => test());

  if (!eligibilityViolation) {
    logger.info('client_eligibility_check_success');

    return true;
  }

  const { name } = eligibilityViolation;

  logger.fpti(`client_eligibility_check_failure_${name}`, {
    error_code: name,
    error_description: 'lite_ineligible',
    state_name: 'BILLING',
    transition_name: 'prepare_redirect',
  });

  return false;
};
